<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>水科院预警</h6>
      <el-button
        class="titBtn"
        type="primary"
        icon="el-icon-plus"
        @click="addClick()"
        >上传预警信息</el-button
      >
      <!-- <addressTree @obj="objdata" @close="treeClose"></addressTree> -->
    </div>
    <div class="tabBody">
      <el-table
        :data="tabledata"
        :height="tableHeight"
        border
        :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }"
      >
        <el-table-column
          type="index"
          align="center"
          width="45"
          label="序号"
        ></el-table-column>
        <el-table-column
          prop="title"
          align="center"
          label="标题"
        ></el-table-column>
        <el-table-column
          prop="period"
          align="center"
          label="期数"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="releaseDate"
          align="center"
          label="预警日期"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="content"
          align="center"
          label="内容"
        ></el-table-column>
        <el-table-column
          prop="pcFile"
          align="center"
          label="降雨覆盖图"
          width="150">
        <template slot-scope="scope">
          <el-image v-for="(item, index) in scope.row.pcFile" :key="index" :src="item.urlHttp"
                :preview-src-list="[item.urlHttp]" style="width: 100px;height: 60px;">
          </el-image>
        </template>
      </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <!-- <el-button
              type="success"
              class="tableedit"
              icon="el-icon-edit"
              circle
              @click="edits(scope.row, scope.$index)"
            ></el-button> -->
            <el-button
              type="warning"
              class="tableedit"
              icon="el-icon-delete"
              circle
              @click="deletes(scope.row, scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fye">
      <pagintion
        @dsydata="DsyData"
        @dstdata="DstData"
        :ToTal="total"
        :pageNums="pageNums"
      ></pagintion>
    </div>
    <earlyWarningpopup
      v-if="dialogVisible == true"
      @getcancel="Getcancel"
      @adddata="Adddata"
    ></earlyWarningpopup>
  </div>
</template>

<script>
import { selectSkyTempWarnForPage, deleteSkyTempWarn } from "@/api/api";
import addressTree from "@/components/mangement/addressTree.vue";
import pagintion from "@/components/mangement/pagintion.vue";
import earlyWarningpopup from "../popup/earlyWarningpopup.vue";

export default {
  data() {
    return {
      dw: "",
      tabledata: [],
      tableHeight: window.innerHeight - 180,
      total: 0,
      pageSize: 20, //每页多少条数据分页
      pageNum: 1, //当前页
      pageNums: null,
      username: "",
      dw: "",
      dialogVisible: false,
      Addsid: []
    };
  },
  components: {
    addressTree,
    pagintion,
    earlyWarningpopup
  },
  mounted() {
    let params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum
    };
    this.list(params);
  },
  methods: {
    //调用接口获得防汛值班列表
    list(params) {
      selectSkyTempWarnForPage(params).then(res => {
        this.total = res.total;
        this.tabledata = res.data;
      });
    },
    Getcancel(data) {
      console.log(data);
      this.dialogVisible = data.dialogVisible;
    },
    addClick() {
      this.dialogVisible = true;
    },
    treeClose() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.list(params);
    },
    objdata(data) {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
        // ydbCode: data.ydbCode
      };
      this.list(params);
    },
    Adddata(data) {
      this.dialogVisible = data.dialogVisible;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.list(params);
    },
    deletes(row, index) {
      this.$confirm("确定删除本条预警数据吗?此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(action => {
          if (action === "confirm") {
            deleteSkyTempWarn({ id: row.id }).then(res => {
              if (res.code == 200) {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "success"
                });
                let params = {
                  pageSize: this.pageSize,
                  pageNum: this.pageNum
                };
                this.list(params);
              } else {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "success"
                });
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "已取消",
            type: "warning"
          });
        });
    },
    DsyData(data) {
      //多少页
      this.pageNum = data.dsy;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.list(params);
    },
    DstData(data) {
      //多少条
      this.pageSize = data.dst;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.list(params);
    }
  }
};
</script>

<style scoped>
@import url("../../../common/css/mangementall.css");
.querys {
  height: 30px;
  float: right;
  width: 200px;
  margin-top: 10px;
  margin-right: 10px;
}

>>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;
  font-size: 14px;
}
</style>
